import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import errorToastMiddleware from "../middlewares/errorToastMiddleware";
import rootReducer from "./rootReducer";

export default function rootStore(initialState = {}) {
    return createStore(rootReducer(), initialState, composeWithDevTools(applyMiddleware(thunk, errorToastMiddleware())));
}
